module.exports = __webpack_public_path__ + "static/assets/d3db540ccce99e65df5abe11235b7fca.png";